module.exports = __webpack_public_path__ + "static/img/img_logo_dibu.fe55df7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/img_logo_dibu.png
// module id = TSpH
// module chunks = 1